import React from 'react';
import { FileText, ShieldAlert, UserMinus, Activity, LogOut, RefreshCw, Banknote, AlertTriangle, Medal, TrendingUp } from 'lucide-react';
const services = [{
  icon: ShieldAlert,
  title: 'Оскарження штрафу ТЦК',
  description: 'Аналіз правомірності накладення штрафу, підготовка скарги та повне представництво у суді.'
}, {
  icon: FileText,
  title: 'Отримання відстрочки',
  description: 'Збір пакету документів, підготовка аргументованої заяви та юридичний супровід процесу.'
}, {
  icon: UserMinus,
  title: 'Виключення з обліку',
  description: "Супровід процедури виключення з військового обліку за станом здоров'я або іншими підставами."
}, {
  icon: Activity,
  title: 'Оскарження рішень ВЛК',
  description: 'Допомога в оскарженні неправомірних висновків комісії до Центральної ВЛК або в суді.'
}, {
  icon: LogOut,
  title: 'Звільнення зі служби',
  description: 'Консультації та підготовка рапортів для законного звільнення з лав ЗСУ.'
}, {
  icon: RefreshCw,
  title: 'Переведення у іншу ВЧ',
  description: 'Юридична допомога в правильному оформленні відношення та рапорту на переведення.'
}, {
  icon: Banknote,
  title: 'Виплати військовим',
  description: "Допомога в отриманні ОГД за поранення, інвалідність, а також виплат сім'ям загиблих."
}, {
  icon: AlertTriangle,
  title: 'Захист при СЗЧ',
  description: 'Професійний захист у кримінальних провадженнях щодо самовільного залишення частини.'
}, {
  icon: Medal,
  title: 'Статус УБД',
  description: 'Допомога у зборі доказів участі в бойових діях та супровід процедури отримання статусу.'
}, {
  icon: TrendingUp,
  title: 'Індексація виплат',
  description: 'Перерахунок та стягнення недоплаченого грошового забезпечення через суд.'
}];
export function Services() {
  return <section id="services" className="py-24 bg-white" data-id="element-96">
      <div className="max-w-7xl mx-auto px-6" data-id="element-97">
        <div className="text-center max-w-2xl mx-auto mb-16" data-id="element-98">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4 tracking-tight" data-id="element-99">
            Спектр послуг
          </h2>
          <p className="text-slate-500 text-lg" data-id="element-100">
            Ми надаємо вичерпну юридичну підтримку, захищаючи ваші права на
            кожному етапі.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-101">
          {services.map((service, index) => <div key={index} className="p-8 rounded-3xl bg-white border border-slate-100 hover:border-slate-200 hover:shadow-[0_8px_30px_rgb(0,0,0,0.04)] transition-all duration-300 group" data-id="element-102">
              <div className="w-14 h-14 rounded-2xl bg-slate-50 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-103">
                <service.icon className="w-7 h-7 text-slate-700 stroke-[1.5]" data-id="element-104" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-105">
                {service.title}
              </h3>
              <p className="text-slate-500 leading-relaxed text-sm" data-id="element-106">
                {service.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}